import { Configuration, ApiConfigOptions } from '@sg/api/base-api-lib';

export interface CountriesApiConfigOptions extends ApiConfigOptions {}
export class CountriesApiConfig extends Configuration {
  constructor(configOptions?: CountriesApiConfigOptions) {
    super({ ...{}, ...(configOptions || {}) });
  }
}
